import { handleActions } from 'redux-actions';
import {
  setCurrentNotification,
  loadAllNotifications,
  loadAllNotificationsMassive,
  paginateNotifications,
  paginateNotificationsMassive,
  filterNotifications,
  changeSortConfigNotification,
  changeSortConfigNotificationMassive,
  getAttachs,
  removeAttach,
  getCurrentItemId,
  saveAlert,
  searchNotifications,
  searchNotificationsMassive,
  setClearNotificationsList,
  setClearNotificationsMassiveList,
  refreshNotifications,
  setAll,
  setMassiveAll,
  getSaveFile,
  removeDocumentFile,
  setCollapseNotify,
  goBackBasicData,
  setShowTypeNotifications,
} from 'redux/actions/notificationActions';

const defaultState = {
  currentNotification: null,
  currentNotificationMassive: null,
  notifications: [],
  notificationsMassive: [],
  currentNotifications: [],
  currentNotificationsMassive: [],
  sortConfig: [],
  sortConfigMassive: [],
  selectedFiles: [],
  searchValue: undefined,
  searchMassiveValue: undefined,
  currentItemId: '',
  isSaveAlert: false,
  clearList: false,
  refresh: false,
  allNotifications: [],
  allNotificationsMassive: [],
  saveFiles: [],
  isCollapse: false,
  isBackBasicData: false,
  showTypeNotifications: false,
};

export default handleActions(
  {
    [setCurrentNotification](state, action) {
      return { ...state, currentNotification: action.payload };
    },
    [loadAllNotifications](state, action) {
      return { ...state, notifications: action.payload };
    },
    [loadAllNotificationsMassive](state, action) {
      return { ...state, notificationsMassive: action.payload };
    },
    [setAll](state, action) {
      return { ...state, allNotifications: action.payload };
    },
    [setMassiveAll](state, action) {
      return { ...state, allNotificationsMassive: action.payload };
    },
    [paginateNotifications](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentNotifications = [...state.notifications].slice(start, end);
      return { ...state, currentNotifications };
    },
    [paginateNotificationsMassive](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentNotificationsMassive = [...state.notificationsMassive].slice(start, end);
      return { ...state, currentNotificationsMassive };
    },
    [filterNotifications](state, action) {
      const { value } = action.payload;
      const notifications = state.notifications.filter(
        (notification) =>
          value === '' ||
          notification.name.toUpperCase().includes(value) ||
          notification.name.toLowerCase().includes(value) ||
          notification.dateBegin.includes(value) ||
          notification.dateEnd.includes(value) ||
          notification.hourAlert.includes(value)
      );
      return { ...state, notifications };
    },
    [changeSortConfigNotification](state, action) {
      const { fieldName, isSort } = action.payload;
      return {
        ...state,
        sortConfig: [{ model: 'Notify', field: fieldName, asc: isSort }],
      };
    },
    [changeSortConfigNotificationMassive](state, action) {
      const { fieldName, isSort } = action.payload;
      return {
        ...state,
        sortConfigMassive: [{ model: 'GeneralNotify', field: fieldName, asc: isSort }],
      };
    },
    [getAttachs](state, action) {
      return { ...state, selectedFiles: action.payload };
    },
    [removeAttach](state, action) {
      const { index } = action.payload;
      const newFiles = state.selectedFiles.filter((item, i) => i !== index);
      return { ...state, selectedFiles: newFiles };
    },
    [getCurrentItemId](state, action) {
      return { ...state, currentItemId: action.payload };
    },
    [saveAlert](state, action) {
      return { ...state, isSaveAlert: action.payload };
    },
    [refreshNotifications](state, action) {
      const refresh = action.payload;
      const searchValue = refresh ? '' : state.searchValue;
      const sortConfig = refresh ? [] : state.sortConfig;
      return { ...state, refresh, searchValue, sortConfig };
    },
    [setClearNotificationsList](state, action) {
      const clearList = action.payload;
      const searchValue = clearList ? undefined : state.searchValue;
      return { ...state, searchValue, clearList };
    },
    [setClearNotificationsMassiveList](state, action) {
      const clearList = action.payload;
      const searchMassiveValue = clearList ? undefined : state.searchMassiveValue;
      return { ...state, searchMassiveValue, clearList };
    },
    [searchNotifications](state, action) {
      return { ...state, searchValue: action.payload };
    },
    [searchNotificationsMassive](state, action) {
      return { ...state, searchMassiveValue: action.payload };
    },
    [getSaveFile](state, action) {
      return { ...state, saveFiles: action.payload };
    },
    [removeDocumentFile](state, action) {
      const { index } = action.payload;
      const newFiles = state.saveFiles.filter((item, i) => i !== index);
      return { ...state, saveFiles: newFiles };
    },
    [setCollapseNotify](state, action) {
      return { ...state, isCollapse: action.payload };
    },
    [goBackBasicData](state, action) {
      return { ...state, isBackBasicData: action.payload };
    },
    [setShowTypeNotifications](state, action) {
      return { ...state, showTypeNotifications: action.payload };
    },
  },
  defaultState
);
